import Swiper from "swiper/bundle";
import "swiper/css/bundle";

const swiperCourses = new Swiper(".swiper-courses", {
  observer: false,
  observeParents: false,
  resizeObserver: false,
  
  slidesPerView: 1,
  centerInsufficientSlides: true,
  snapToSlideEdge: true,
  autoHeight: false,
  grabCursor: true,
  navigation: {
    nextEl: ".swbtn-next-courses",
    prevEl: ".swbtn-prev-courses",
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  breakpoints: {
    640: {
      slidesPerView: 1,
      spaceBetween: 20,
    },
    768: {
      slidesPerView: 2,
      spaceBetween: 40,
    },
    1024: {
      slidesPerView: 3,
      spaceBetween: 50,
    },
  },
  autoplay: {
    delay: 4000,
    pauseOnMouseEnter: true,
    disableOnInteraction: true,
    waitForTransition: true,
  },
});

const swiperArtworks = new Swiper(".swiper-mentor-arts", {
  observer: false,
  observeParents: false,
  resizeObserver: false,

  slidesPerView: 1,
  effect: "fade",
  fadeEffect: {
    crossFade: true,
  },
  parallax: true,
  grabCursor: true,
  longSwipes: false,
  noSwiping: true,

  autoplay: {
    delay: 4000,
  },
});

const swiperMentors = new Swiper(".swiper-mentors", {
  observer: false,
  observeParents: false,
  resizeObserver: false,

  slidesPerView: 1,

  navigation: {
    nextEl: ".swbtn-next-mentor",
    prevEl: ".swbtn-prev-mentor",
  },
  pagination: {
    el: ".swiper-pagination",
  },
});

const swiperTestimonials = new Swiper(".swiper-testimonies", {
  observer: false,
  observeParents: false,
  resizeObserver: false,

  slidesPerView: 1,
  loop: true,
  speed: 7000,
  allowTouchMove: false,
  autoplay: {
    delay: 1,
    disableOnInteraction: false,
  },
  breakpoints: {
    640: {
      slidesPerView: 1,
      spaceBetween: 20,
    },
    768: {
      slidesPerView: 2,
      spaceBetween: 40,
    },
    1024: {
      slidesPerView: 3,
      spaceBetween: 50,
    },
  },
});
